import gql from "graphql-tag";

export const dealerIncentiveTypeListQuery = gql`
  query dealerIncentiveTypeList {
    dealerIncentiveTypeList {
      id
      name
    }
  }
`;
